export default "__VITE_ASSET__BbZEd92F__"